import { Container } from "@mantine/core";
import { Navigate, Route, Routes, useNavigate, useLocation } from "react-router-dom";

import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import MainContainer from "../../components/MainContainer";
import Nav from "../../components/Navbar";
import Facility from "./Facility";
import FacilityType from "./FacilityType";
import Note from "./Note";
import Patient from "./Patient";
import Reports from "./Report";
import Setting from "./Setting";
import Notification from "./Notificaton";
import Staff from "./Staff";
import Task from "./Task";
import TaskType from "./Task/TaskType.jsx";
import AddTask from "./Task/AddTask.jsx";
import useStyles from "./style";
import {
  isIncompleteAddressDetails,
  isSubscriptionExpired,
  removeCookie,
  setCookie,
} from "../../utils";
import { useEffect, useState } from "react";
import Medication from "./Medication";
import SupportPlan from "./SupportPlan";
import SingleTicket from "../SingleTicket/index.jsx";
import HaveProblem from "../HaveProblem/index.jsx";
import ViewTask from "./Task/ViewTask.jsx";
import EditTask from "./Task/EditTask.jsx";
import Client from "./Client/index.jsx";
import NewDashboard from "./Dashboard/NewDashboard.jsx";
import NewNoteType from "./NoteType/NewNoteType.jsx";
import Billing from "./Billling/index.jsx";
import BillingPaid from "./BillingPaid/index.jsx";
import BillingRejected from "./BillingRejected/index.jsx";
import BillingClaimForm from "./BillingClaimForm/index.js";
import BillingInvoices from "./BillingInvoices/index.js";
import StaffDetails from "./Staff/StaffDetails.jsx";
import { StaffAttendance } from "./Staff/StaffAttendance.jsx";
import FacilityDetails from "./Facility/FacilityDetails.jsx";
import { getProfile } from "../../services/profile.js";
import SkyPointHeader from "../../components/SkyPointHeader/index.jsx";
import AddContractor from "./AddContractor/index.jsx";
import CompliancePage from "./Compliance";
// od1147
// import ComplianceOfficer from "./ComplianceOfficer";
import BillingSettings from "./BillingSettings";
import Scheduler from "./Scheduler";

const Home = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const isClaimWizard = location.pathname.includes('billing-claim-form');
  let token = Cookies.get("token");
  const { profile } = useSelector((state) => {
    return state?.profile;
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const qrSession = (() => {
    try {
      return JSON.parse(localStorage.getItem("qr_session"));
    } catch {
      return null;
    }
  })();

  const billing = useSelector((state) => state.featureFlags.billing);
  const canAccessBilling = !profile?.user?.role
    ? true
    : profile?.user?.permissions?.billing === true;
  const currentDate = profile?.currentDate
    ? new Date(profile?.currentDate)
    : new Date();
  const cutoffDate = new Date("2026-1-30");

  // useEffect(() => {
  //   const isMissingAddressInfo = currentDate > cutoffDate && isIncompleteAddressDetails(profile);

  //   if (isMissingAddressInfo) {
  //     navigate("/home/settings?selectedTab=business");
  //   }
  // }, [profile?.business]);

  useEffect(() => {
    const isExpired = isSubscriptionExpired();
    if (isExpired) {
      if (profile?.user?.type === "staff") return navigate("/home/settings");
      navigate("/home/settings?selectedTab=upgrade");
    }
  }, [profile?.subscription?.expiredAt]);

  useEffect(() => {
    const isActivated = profile?.signature?.length === 0;
    if (isActivated) {
      if (profile?.user?.type === "staff");
      navigate("/home/settings?selectedTab=my-signature");
    }
  }, [profile?.signature]);

  // when admin reset staff's phone number reset then this useEffect will run
  // useEffect(() => {
  //   const isResetStaff2FA = profile?.user?.isPhoneVerified === false;
  //   if (isResetStaff2FA) {
  //     navigate("/home/settings", {
  //       state: { selectedTab: "security", reset2fa: true },
  //     });
  //   }
  // }, [profile]);

  // const currentDate = profile?.currentDate ? new Date(profile?.currentDate) : new Date();
  // const cutoffDate = new Date("2025-12-30");

  // useEffect(() => {
  //   if (
  //     currentDate > cutoffDate &&
  //     profile?.user?.twoFactorVerified === false
  //   ) {
  //     navigate("/home/settings", {
  //       state: { selectedTab: "security", reset2fa: true },
  //     });
  //   }
  // }, [profile]);

  if (token && !profile?.business && profile?.user?.type !== "staff")
    return <Navigate to="/signup" state={{ token: token }} />;

  const PermissionProtectedRoute = ({ permissionKey, children }) => {
    const permissions = profile?.user?.permissions;

    if (!profile?.user?.role && !profile?.user?.type) {
      return children;
    }

    // A plain "staff" role never sees these modules, regardless of the
    // permissions object (mirrors Navbar's DEFAULT_STAFF_NOT_SEE).
    if (
      profile?.user?.role === "staff" &&
      // STAFF_DEFAULT_DENIED_KEYS.includes(permissionKey) &&
      permissions?.[permissionKey] !== true
    ) {
      return <Navigate to="/home/dashboard" replace />;
    }

    // Note Type (settings) is admin-only within staff accounts, regardless
    // of the broader "note" permission — mirrors the guard in NoteType/index.jsx.
    if (permissionKey === "noteSettings") {
      const isAdmin = profile?.user?.role === "admin";
      if (!isAdmin || permissions?.noteSettings !== true) {
        return <Navigate to="/home/dashboard" replace />;
      }
      return children;
    }

    // Any staff-type account (staff/admin/contractor role) with this module
    // explicitly turned off must not reach it via direct URL either.
    if (permissions?.[permissionKey] === false) {
      return <Navigate to="/home/dashboard" replace />;
    }

    // Missing permissions object, or missing/null key on it, is allowed for
    // backward compatibility with accounts created before permissions existed.
    if (!permissions || permissions[permissionKey] == null) {
      return children;
    }
    // if (!permissions || typeof permissions !== "object") {
    //   return children;
    // }

    if (permissions[permissionKey] === true) {
      return children;
    }

    return <Navigate to="/home/dashboard" replace />;
  };

  if (!token) return <Navigate to="/login" />;

  // if (signatureLoading) return <div>Loading...</div>;

  return (
    <MainContainer isSidebarOpen={isSidebarOpen}>
      {/* {Boolean(localStorage.getItem("isProviderView")) === true && (
        <div style={{ height: "65px" }}>
          <SkyPointHeader />
        </div>
      )} */}
      <Container className={classes.wrapper} fluid p={0}>
        {!isClaimWizard && (
          <Nav
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
          />
        )}
        <Routes>
          {qrSession ? (
            <>
              <Route path="client" element={<Client />} />
              <Route path="patient" element={<Patient />} />
              <Route
                path="*"
                element={
                  <Navigate
                    to="/home/client"
                    state={{ clientId: qrSession.clientId }}
                    replace
                  />
                }
              />
            </>
          ) : (
            <>
              <Route
                index
                element={<NewDashboard isSidebarOpen={isSidebarOpen} />}
              />
              <Route
                path="dashboard"
                element={<NewDashboard isSidebarOpen={isSidebarOpen} />}
              />
              <Route path="supportPlan" element={<SupportPlan />} />
              {/* <Route path="scheduler" element={<Scheduler />} /> */}
              <Route
                path="facility"
                element={
                  <PermissionProtectedRoute permissionKey="facility">
                    <Facility />
                  </PermissionProtectedRoute>
                }
              />
              <Route
                path="facility/:id/:mode"
                element={
                  <PermissionProtectedRoute permissionKey="facility">
                    <FacilityDetails />
                  </PermissionProtectedRoute>
                }
              />
              <Route
                path="staff"
                element={
                  <PermissionProtectedRoute permissionKey="staff">
                    <Staff />
                  </PermissionProtectedRoute>
                }
              />
              <Route
                path="staff/:id/:mode"
                element={
                  <PermissionProtectedRoute permissionKey="staff">
                    <StaffDetails />
                  </PermissionProtectedRoute>
                }
              />
              <Route
                path="staff/manage-attendance/:id"
                element={
                  <PermissionProtectedRoute permissionKey="staff">
                    <StaffAttendance />
                  </PermissionProtectedRoute>
                }
              />
              <Route
                path="facilitytype"
                element={
                  <PermissionProtectedRoute permissionKey="facility">
                    <FacilityType />
                  </PermissionProtectedRoute>
                }
              />
              <Route path="client" element={<Client />} />
              <Route path="patient" element={<Patient />} />
              <Route
                path="medication"
                element={
                  <PermissionProtectedRoute permissionKey="medication">
                    <Medication />
                  </PermissionProtectedRoute>
                }
              />
              <Route
                path="note"
                element={
                  <PermissionProtectedRoute permissionKey="note">
                    <Note />
                  </PermissionProtectedRoute>
                }
              />
              <Route
                path="notetype"
                element={
                  <PermissionProtectedRoute permissionKey="noteSettings">
                    <NewNoteType />
                  </PermissionProtectedRoute>
                }
              />
              <Route path="settings" element={<Setting />} />
              <Route path="add-contractor" element={<AddContractor />} />
              <Route path="notifications" element={<Notification />} />
              <Route
                path="tasks"
                element={
                  <PermissionProtectedRoute permissionKey="task">
                    <Task />
                  </PermissionProtectedRoute>
                }
              />
              <Route
                path="taskType"
                element={
                  <PermissionProtectedRoute permissionKey="task">
                    <TaskType />
                  </PermissionProtectedRoute>
                }
              />
              <Route
                path="add-task"
                element={
                  <PermissionProtectedRoute permissionKey="task">
                    <AddTask />
                  </PermissionProtectedRoute>
                }
              />
              <Route
                path="view-task"
                element={
                  <PermissionProtectedRoute permissionKey="task">
                    <ViewTask />
                  </PermissionProtectedRoute>
                }
              />
              <Route
                path="edit-task"
                element={
                  <PermissionProtectedRoute permissionKey="task">
                    <EditTask />
                  </PermissionProtectedRoute>
                }
              />
              <Route path="ticket/:id" element={<SingleTicket />} />
              <Route path="create-ticket" element={<HaveProblem />} />
              {/* {canAccessBilling && (
                <> */}
                  <Route
                    path="billing"
                    element={
                      <PermissionProtectedRoute permissionKey="billing">
                        <Billing />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="billing-paid"
                    element={
                      <PermissionProtectedRoute permissionKey="billing">
                        <BillingPaid />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="billing-rejected"
                    element={
                      <PermissionProtectedRoute permissionKey="billing">
                        <BillingRejected />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="billing-claim-form"
                    element={
                      <PermissionProtectedRoute permissionKey="billing">
                        <BillingClaimForm />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="billing-settings"
                    element={<BillingSettings />}
                  />
                {/* </>
              )} */}
              <Route
                path="invoices"
                element={
                  <PermissionProtectedRoute permissionKey="invoice">
                    <BillingInvoices />
                  </PermissionProtectedRoute>
                }
              />
              <Route path="compliance" element={<CompliancePage />} />
              {/* od1147 */}
              {/* <Route path="compliance-officer" element={<ComplianceOfficer />} /> */}
            </>
          )}
        </Routes>
      </Container>
    </MainContainer>
  );
};
export default Home;
